import React, { useState, useRef } from 'react';
import {getStudyMatirialCCavenueApi } from '../../actions/CCAvenueAction'
import swal from 'sweetalert';



const CCAvenueStudyMaterial = ({paymentConfig,userDetail,feeDetail}) => {
    const formRef = useRef(null);
    const [loading,setLoading] = useState(false)
    const [encRequestRes, setEncRequestRes] = useState()
    const [formActionUrl,setFormActionUrl] = useState();

    const {form_num,id} = userDetail !==undefined && userDetail
    let accessCode = `${paymentConfig.access_code}`

    const checkout = async () => {
        setLoading(true)
        const data = {
            student_id: id,
            gateway_id: paymentConfig.id,
            merchant_id:paymentConfig?.merchant_id,
            success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/success`,
            failure_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/failure`,
          }
      

        try {
          const EncUrlRes = await getStudyMatirialCCavenueApi(data)

          if (EncUrlRes.encrypted_data !== undefined) {
              setLoading(true)
              setEncRequestRes(EncUrlRes?.encrypted_data);
              setFormActionUrl(EncUrlRes?.ccavenue_url)
              setTimeout(() => { formRef.current.submit(); }, 1000)
             
          }
          else {
              swal(`Payment Failed! We couldn't process your payment. Please Try Again!`, '', 'error');
              setLoading(false)
          }
          
        } catch (error) {
          console.log('ccavenue error...',error)
        }
        
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>Pay with CCAvenue</button>
            }
                
                <form ref={formRef}
                    id="nonseamless"
                    method="POST"
                    name="redirect"
                    action={formActionUrl !==undefined ? formActionUrl : ''}
                    >
                    <input type="hidden" id="encRequest" name="encRequest" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form>
            </div>

        </React.Fragment>
    )
}

export default CCAvenueStudyMaterial